<div class="allergy-notice" *ngIf="visible$ | async">
  <svg class="allergy-notice__icon" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="9"></circle>
    <path d="M12 7.5v5.5M12 16.4v.1"></path>
  </svg>
  <span>{{ 'allergyNotice' | translate }}</span>
</div>
